import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
} from "@mui/material";
import { Box } from "@mui/system";
import React from "react";

const armadaItems = [
  { value: "1", name: "Mobil Tangki" },
  { value: "2", name: "Mobil Tangki Industri" },
  { value: "3", name: "Skid Tank" },
  { value: "4", name: "..." },
];

const kategoriInsidenItems = [
  { value: "1", name: "Aktif" },
  { value: "2", name: "Pasif" },
];

const kapasitasMobilTangkiItems = [
  { value: "1", name: "16 KL" },
  { value: "2", name: "20 KL" },
  { value: "3", name: "24 KL" },
  { value: "4", name: "..." },
];

const muatanItems = [
  { value: "1", name: "Kosong" },
  { value: "2", name: "Isi" },
];

const tujuanAngkutanItems = [
  { value: "1", name: "SPDN" },
  { value: "2", name: "TBBM" },
  { value: "3", name: "Depot LPG" },
  { value: "4", name: "..." },
];

const jumlahAMTItems = [
  { value: "1", name: "Single Driver" },
  { value: "2", name: "2 AMT" },
];

const jenisPengelolaanItems = [
  { value: "1", name: "Pola Sewa" },
  { value: "2", name: "Pola Tarif" },
];

const pengelolaItems = [
  { value: "1", name: "PT Elnusa Petrofin" },
  { value: "2", name: "PT Pertamina Patra Niaga" },
  { value: "3", name: "Lainnya" },
];

const DetailKlasifikasiKecelakaanTransportasi = ({
  fieldStyles,
  setInputFields,
  inputFields,
}) => {
  return (
    <>
      <h4>Detail Klasifikasi Kecelakaan Trasnportasi</h4>
      <Box component="div" sx={fieldStyles}>
        <Grid>
          <Stack spacing={2} direction="row">
            <FormControl variant="standard" fullWidth>
              <InputLabel id="idPTK">Armada</InputLabel>
              <Select
                labelId="lbl1"
                id="idPTK"
                label="Armada"
                onChange={(e) => {
                  setInputFields({
                    ...inputFields,
                    armada: e.target.value,
                  });
                }}
              >
                {armadaItems.map((item, idx) => (
                  <MenuItem value={item.value} key={idx}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl variant="standard" fullWidth>
              <InputLabel id="idPTK">Kategori Insiden</InputLabel>
              <Select
                labelId="lbl1"
                id="idPTK"
                label="Kategori Insiden"
                onChange={(e) => {
                  setInputFields({
                    ...inputFields,
                    kategoriInsiden: e.target.value,
                  });
                }}
              >
                {kategoriInsidenItems.map((item, idx) => (
                  <MenuItem value={item.value} key={idx}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
          <Stack spacing={2} direction="row">
            <FormControl variant="standard" fullWidth>
              <InputLabel id="idPTK">Kapasitas Mobil Tangki</InputLabel>
              <Select
                labelId="lbl1"
                id="idPTK"
                label="Kapasitas Mobil Tangki"
                onChange={(e) => {
                  setInputFields({
                    ...inputFields,
                    kapasitasMobilTangki: e.target.value,
                  });
                }}
              >
                {kapasitasMobilTangkiItems.map((item, idx) => (
                  <MenuItem value={item.value} key={idx}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl variant="standard" fullWidth>
              <InputLabel id="idPTK">Muatan</InputLabel>
              <Select
                labelId="lbl1"
                id="idPTK"
                label="Potensi Tingkat Keparahan"
                onChange={(e) => {
                  setInputFields({
                    ...inputFields,
                    muatan: e.target.value,
                  });
                }}
              >
                {muatanItems.map((item, idx) => (
                  <MenuItem value={item.value} key={idx}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
          <Stack spacing={2} direction="row">
            <FormControl variant="standard" fullWidth>
              <InputLabel id="idPTK">Tujuan Angkutan</InputLabel>
              <Select
                labelId="lbl1"
                id="idPTK"
                label="Tujuan Angkutan"
                onChange={(e) => {
                  setInputFields({
                    ...inputFields,
                    tujuanAngkutan: e.target.value,
                  });
                }}
              >
                {tujuanAngkutanItems.map((item, idx) => (
                  <MenuItem value={item.value} key={idx}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl variant="standard" fullWidth>
              <InputLabel id="idPTK">Jumlah AMT</InputLabel>
              <Select
                labelId="lbl1"
                id="idPTK"
                label="Jumlah AMT"
                onChange={(e) => {
                  setInputFields({
                    ...inputFields,
                    jumlahAMT: e.target.value,
                  });
                }}
              >
                {jumlahAMTItems.map((item, idx) => (
                  <MenuItem value={item.value} key={idx}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
          <Stack spacing={2} direction="row">
            <FormControl variant="standard" fullWidth>
              <InputLabel id="idPTK">Jenis Pengelolaan</InputLabel>
              <Select
                labelId="lbl1"
                id="idPTK"
                label="Jenis Pengelolaan"
                onChange={(e) => {
                  setInputFields({
                    ...inputFields,
                    jenisPengelolaan: e.target.value,
                  });
                }}
              >
                {jenisPengelolaanItems.map((item, idx) => (
                  <MenuItem value={item.value} key={idx}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl variant="standard" fullWidth>
              <InputLabel id="idPTK">Pengelolaan</InputLabel>
              <Select
                labelId="lbl1"
                id="idPTK"
                label="Pengelolaan"
                onChange={(e) => {
                  setInputFields({
                    ...inputFields,
                    pengelola: e.target.value,
                  });
                }}
              >
                {pengelolaItems.map((item, idx) => (
                  <MenuItem value={item.value} key={idx}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      </Box>
    </>
  );
};

export default DetailKlasifikasiKecelakaanTransportasi;
